import Mixpanel from "utils/mixpanel";
import { PATHS } from "constants/pathConstants";
import TargetIcon from "assets/images/Target.svg";
import DashboardCtaCard from ".";
import Translate from "translate/Translate";

const HealthSurveyDashboardCtaCard = () => {
  return (
    <DashboardCtaCard
      icon={TargetIcon}
      header={<Translate text={"Health Survey"} />}
      subheader={
        <Translate
          text={
            "Please fill out our Health Questionnaire. This will help us suggest the next steps you can take!"
          }
        />
      }
      link={{
        onClick: () => {
          Mixpanel.track(`Dashboard CTA Clicked - Health Survey`);
        },
        overrideClick: false,
        text: "Complete",
        url: PATHS.GETTING_STARTED_SURVEY
      }}
    />
  );
};

export default HealthSurveyDashboardCtaCard;
